// Inspired by https://github.com/focusOtter/appsync-cdk-cognito-fullstack/blob/main/frontend/pages/_app.js
// and by https://tiny.amazon.com/16r4ucfdx/ABDAIDiscoveryUICommonsWebsite/mainline/config.beta.ts
import {AUTH_TYPE} from "aws-appsync";
import {Amplify, Auth} from "aws-amplify";
import {logger} from "src/logger";

const redirectUrl = window.location.hostname.includes("localhost")
    ? "http://localhost:4321/index.html"
    : 'https://us-east-1.gamma.ksavvy.kaspian.amazon.dev';

const amplifyConfig = {
  Auth: {
    region: 'us-east-1',
    userPoolId: 'us-east-1_WwooVUBtW',
    userPoolWebClientId: '7rrf2nrnneo8l0dqkhoaaum9fc',
    mandatorySignIn: true,
  },
  aws_project_region: 'us-east-1',
  aws_appsync_graphqlEndpoint: 'https://ix345jegdjfczevpctzujqhzcu.appsync-api.us-east-1.amazonaws.com/graphql',
  aws_appsync_region: 'us-east-1',
  aws_appsync_authenticationType: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
  oauth: {
    domain: 'ksavvy-gamma.auth.us-east-1.amazoncognito.com',
    scope: ['openid'],
    redirectSignIn: redirectUrl,
    redirectSignOut: redirectUrl,
    responseType: 'code',
  },
}

Amplify.Logger.LOG_LEVEL = 'DEBUG';

async function loginRedirect() {
  await Auth.federatedSignIn();
}

// Taken from https://tiny.amazon.com/g2zilqsk/ABDAIDiscoveryUICommonsWebsite/mainline/App.tsx#L21
export const signInWithFederatedCredential = async () => {

  Amplify.configure(amplifyConfig);

  // Obtain authenticated user
  try {
    const user = await Auth.currentAuthenticatedUser();
    if (!user) {
      // User does not exist. Call out to federate
      await loginRedirect();
    } else {
      return user;
    }
  } catch (e) {
    await logger.warn(`Error with auth: ${e}`);
    // Error with current user (usually token expiration related)
    await loginRedirect();
  }
};
